import React from 'react';
import './printTemplate.scss';
import usdaLogoDiagram from '../../../assets/images/usda-logo-black.png';
import { WaterwaySizingParamsDTO, WaterwaySizingResponseDTO } from 'cd-eft/_codegen_/openapi-generator/eft-set';
interface IReportProps {
    inputs: WaterwaySizingParamsDTO;
    outputs: WaterwaySizingResponseDTO;
    formData: any;
    others: any;
}

export const TablePrintComponent = (props: IReportProps) => {
    const { formData, inputs, outputs, others } = props;
    return (
        <table className="report-table-container">
            <tbody>
                <tr>
                    <td>
                        <table className="input-table-class">
                            <thead>
                                <tr>
                                    <th className='section-header' colSpan={3}>{inputs.channelParams?.channelShapeStr} Inputs</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="underline" scope="row">Channel Data</td>
                                    <td>
                                        <table className='sub-table-class'>
                                            <tbody>
                                                <tr>
                                                    <th >{inputs.channelParams?.channelShapeStr === 'TRAPEZOIDAL' ? 'Bank Slopes,' : 'Limiting BS,'}<br></br>z1{inputs.channelParams?.channelShapeStr === 'TRAPEZOIDAL' ? ',z2' : ''}:</th>
                                                    <td >{inputs.channelParams?.leftSlopeRatio}{inputs.channelParams?.channelShapeStr === 'TRAPEZOIDAL' ? `, ${inputs.channelParams.rightSlopeRatio} ft/ft` : ' ft/ft'}</td>
                                                    <th >Bed Slope:</th>
                                                    <td >{inputs.channelSlope ? `${inputs.channelSlope}%` : 'N/A'}</td>
                                                    <th >Freeboard:</th>
                                                    <td >{inputs.channelParams?.freeBoard ? `${inputs.channelParams?.freeBoard} ft` : 'N/A'}</td>

                                                    {inputs.channelParams?.channelShapeStr === 'TRAPEZOIDAL' ? <th >Min Bed Width:</th> : null}
                                                    {inputs.channelParams?.channelShapeStr === 'TRAPEZOIDAL' ? <td >{inputs.channelParams?.minBedWidth ? `${inputs.channelParams?.minBedWidth} ft` : 'N/A'}</td> : null}

                                                </tr>
                                                <tr>
                                                    <th >Fixed Flow<br></br>Depth:</th>
                                                    <td>{inputs.dataVertex?.depthEdited ? `${inputs.dataVertex.depth} ft` : 'N/A'}</td>
                                                    <th >Fixed Flow Width:</th>
                                                    <td>{inputs.dataVertex?.widthEdited ? `${inputs.dataVertex.width} ft` : 'N/A'}</td>
                                                    <th >Discharge:</th>
                                                    <td>{inputs.dataVertex?.totalQ} cfs</td>
                                                    {inputs.channelParams?.channelShapeStr === 'PARABOLIC' ? <th>Offset 1,2,3: </th> : null}
                                                    {inputs.channelParams?.channelShapeStr === 'PARABOLIC' ? <td>{`${inputs.channelParams.offset1?.toFixed(2)},  ${inputs.channelParams.offset2?.toFixed(2)},  ${inputs.channelParams.offset3?.toFixed(2)}`} </td> : null}
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="underline" scope="row">Soil Data</td>
                                    <td>
                                        <table className='sub-table-class-grey'>
                                            <tbody>
                                                <tr>
                                                    <th >Grain Roughness:</th>
                                                    <td >{inputs.soilParameters?.soilGrainRoughness}</td>
                                                    <th>Allowable Stress:</th>
                                                    <td>{inputs.soilParameters?.allowableStress} lb/sq.ft</td>
                                                </tr>
                                                <tr>
                                                    <th>Soil Type:</th>
                                                    <td>{inputs.soilParameters?.soilTypeStr ? inputs.soilParameters?.soilTypeStr : 'N/A'}</td>
                                                    <th>Void Ratio:</th>
                                                    <td>{inputs.soilParameters?.voidRatio ? inputs.soilParameters?.voidRatio.toFixed(2) : 'N/A'}</td>
                                                </tr>
                                                <tr>
                                                    <th>Plasticity Index:</th>
                                                    <td>{inputs.soilParameters?.plasticityIndex ? inputs.soilParameters?.plasticityIndex.toFixed(2) : 'N/A'}</td>
                                                    <th>d75: </th>
                                                    <td>{inputs.soilParameters?.d75 ? `${inputs.soilParameters?.d75} in` : 'N/A'}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="underline" scope="row">Vegetal Data</td>
                                    <td>
                                        <table className='sub-table-class-vegetal'>
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th >Stem Length</th>
                                                    <th >Density </th>
                                                    <th>Ret Curve Index</th>
                                                    <th>Vegetal Cover Factor</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <th>Stability</th>
                                                    <td>{inputs.vegetalStabilityOption === 'Stem length/density' ? `${inputs.vegetalStabilityParams?.stemLength} ft` : 'N/A'}</td>{/*Stability length*/}
                                                    <td>{inputs.vegetalStabilityOption === 'Stem length/density' ? `${inputs.vegetalStabilityParams?.stemDensity} lb/sq.ft` : 'N/A'}</td>{/*Stability density*/}
                                                    <td>
                                                        {inputs.vegetalStabilityOption === 'Retardance Class' ? `${inputs.vegetalStabilityParams?.rci} (${inputs.vegetalStabilityParams?.retClassStr})` : ''}
                                                        {inputs.vegetalStabilityOption === 'Retardance Curve Index' ? `${inputs.vegetalStabilityParams?.rci}` : ''}
                                                        {inputs.vegetalStabilityOption === 'Stem length/density' ? inputs.vegetalStabilityParams?.rci?.toFixed(2) : ''}
                                                        {inputs.vegetalStabilityOption === "Manning's n" ? 'N/A' : ''}
                                                    </td>
                                                    <td>{others.coverFactor}</td>
                                                </tr>
                                                <tr>
                                                    <th>Capacity</th>
                                                    <td>{inputs.vegetalCapacityOption === 'Stem length/density' ? `${inputs.vegetalCapacityParams?.stemLength} ft` : 'N/A'}</td>
                                                    <td>{inputs.vegetalCapacityOption === 'Stem length/density' ? `${inputs.vegetalCapacityParams?.stemDensity} lb/sq.ft` : 'N/A'}</td>
                                                    <td>
                                                        {inputs.vegetalCapacityOption === 'Retardance Class' ? `${inputs.vegetalCapacityParams?.rci} (${inputs.vegetalCapacityParams?.retClassStr})` : ''}
                                                        {inputs.vegetalCapacityOption === 'Retardance Curve Index' ? `${inputs.vegetalCapacityParams?.rci}` : ''}
                                                        {inputs.vegetalCapacityOption === 'Stem length/density' ? inputs.vegetalCapacityParams?.rci?.toFixed(2) : ''}
                                                        {inputs.vegetalStabilityOption === "Manning's n" ? 'N/A' : ''}
                                                    </td>
                                                    <td></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td>
                        <table className='output-table-class'>
                            <thead>
                                <tr>
                                    <th className='section-header' colSpan={3}>Outputs</th>
                                </tr>
                                <tr>
                                    <td colSpan={3}>Bed Width determined by specified minimum value for Stability Conditions
                                        <br></br>(Stress not the limiting factor)</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th colSpan={3} scope="row">Flow Conditions with Minimum cover (Stability)</th>
                                </tr>
                                <tr>
                                    <td>
                                        <table className='sub-table-class'>

                                            <thead>
                                                <tr>
                                                    <th>Manning's n</th>
                                                    <th>Average Velocity</th>
                                                    <th >Flow Depth</th>
                                                    <th>Effect. Soil Stress</th>
                                                    <th>Flow Width</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>{outputs.stabNString ? outputs.stabNString : 'N/A'}</td>
                                                    <td>{outputs.stabVString ? `${outputs.stabVString} ft/sec` : 'N/A'}</td>
                                                    <td >{outputs.stabFlowDepthString ? `${outputs.stabFlowDepthString} ft` : 'N/A'}</td>
                                                    <td>{outputs.stabSoilStressString ? `${outputs.stabSoilStressString} lb/sec` : 'N/A'}</td>
                                                    <td>{outputs.stabFlowWidthString ? `${outputs.stabFlowWidthString} ft` : 'N/A'}</td>
                                                </tr>
                                            </tbody>
                                            <thead>
                                                <tr>
                                                    <th>X-sect. Area</th>
                                                    <th >Hydraulic Radius</th>
                                                    <th >Bed Width</th>
                                                    <th colSpan={2}>Flow Width w/Fb</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>{outputs.stabXSectAreaString ? `${outputs.stabXSectAreaString} sq.ft` : 'N/A'}</td>
                                                    <td >{outputs.stabHydRadiusString ? `${outputs.stabHydRadiusString} ft` : 'N/A'}</td>
                                                    <td>{outputs.stabBedWidthString ? `${outputs.stabBedWidthString} ft` : 'N/A'}</td>
                                                    <td colSpan={2}>{outputs.stabFlowWidthWFBString ? `${outputs.stabFlowWidthWFBString} ft` : 'N/A'}</td>
                                                </tr>
                                            </tbody>

                                        </table>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <table className='sub-table-class-grey-output'>
                                            <thead>
                                                <tr>
                                                    <th colSpan={5} scope="row">Capacity Flow Conditions</th>
                                                </tr>
                                                <tr>
                                                    <th>Manning's n</th>
                                                    <th>Average Velocity</th>
                                                    <th >Flow Depth</th>
                                                    <th>Flow Width</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>{outputs.capNString ? `${outputs.capNString}` : 'N/A'}</td>
                                                    <td>{outputs.capVString ? `${outputs.capVString} ft/sec` : 'N/A'}</td>
                                                    <td >{outputs.capFlowDepthString ? `${outputs.capFlowDepthString} ft` : 'N/A'}</td>
                                                    <td>{outputs.capFlowWidthString ? `${outputs.capFlowWidthString} ft` : 'N/A'}</td>
                                                    <td></td>
                                                </tr>
                                            </tbody>
                                            <thead>
                                                <tr>
                                                    <th>X-sect. Area</th>
                                                    <th>Hydraulic Radius</th>
                                                    <th >Bed Width</th>
                                                    <th colSpan={2}>Flow Width w/Fb</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>{outputs.capXSectAreaString ? `${outputs.capXSectAreaString} sq.ft` : 'N/A'}</td>
                                                    <td >{outputs.capHydRadiusString ? `${outputs.capHydRadiusString} ft` : 'N/A'}</td>
                                                    <td>{outputs.capBedWidthString ? `${outputs.capBedWidthString} ft` : 'N/A'}</td>
                                                    <td colSpan={2}>{outputs.capFlowWidthWFBString ? `${outputs.capFlowWidthWFBString} ft` : 'N/A'}</td>
                                                </tr>
                                            </tbody>

                                        </table>
                                    </td>
                                </tr>

                                <tr>
                                    <td colSpan={3} className="warning">
                                        {outputs.warningMsgs?.map((message, index) => {
                                            return (<span key={`report-warning-${index}`}>{message}<br /></span>)
                                        })}

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td>
                        <table className='summary-table-class'>
                            <tbody>
                                <tr>
                                    <td style={{ width: "25%" }}>
                                        <img id="usda-logo" src={usdaLogoDiagram} alt="usda logo" />
                                    </td>
                                    <td style={{ width: "25%" }}>
                                        <h2>Waterway Sizing Calculator Report</h2>
                                    </td>
                                    <td style={{ width: "25%" }}>
                                        <table className='pop-up-info'>
                                            <thead>
                                                <tr>
                                                    <th>Date</th>
                                                    <td>{formData.designedByDate}</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <th>Designed</th>
                                                    <td>{formData.designedByName}</td>
                                                </tr>
                                                <tr>
                                                    <th>Drawn</th>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <th>Checked</th>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <th>Approved</th>
                                                    <td></td>
                                                </tr>

                                            </tbody>
                                        </table>

                                    </td>
                                    <td >

                                        <table className='pop-up-info' style={{ width: "25%" }}>
                                            <tbody>
                                                <tr>
                                                    <th>Name</th>
                                                    <td>{formData.name}</td>
                                                </tr>
                                                <tr>
                                                    <th>Practice</th>
                                                    <td>{formData.practice}</td>
                                                </tr>
                                                <tr>
                                                    <th>Location</th>
                                                    <td>{formData.location}</td>
                                                </tr>
                                                <tr>
                                                    <th>Description</th>
                                                    <td>{formData.description}</td>
                                                </tr>


                                            </tbody>
                                        </table>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>




        </table>
    )
}
